import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Response_Processing from "../../layout/Others/Response_Processing";
import AdminSaveHeader from "../../components/CommonComponents/AdminSaveHeader";
import AdminSwitch from "../../components/CommonComponents/AdminSwitch";
import FormContainer from "../../components/CommonComponents/FormContainer";
import Wrapper from "../../components/CommonComponents/Wrapper";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import { toast } from "react-toastify";
import { getItemToken } from "../../Utils/localStorageUtils";
import "./OTPCredentialsSettings.css"
import AdminCustomSelect from "../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../components/CommonComponents/AdminCustomInput";
import AdminCustomArea from "../../components/CommonComponents/AdminCustomArea";
import LeftWrapper from "../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../components/CommonComponents/RightWrapper";

const OTPCredentialsSettings = () => {
    const headers = getItemToken('access_token')
    const [formData, setFormData] = useState({
        otp_vai: "",
        otp_fast2sms_api_key: "",
        otp_24x7sms_api_key: "",
        otp_24x7sms_sender_id: "",
        otp_24x7sms_sevicename: "",
        DLTTemplateID: "",
        template_message: "",
        status: 0,
    })

    const combinedRef = useRef({
        otp_vai: null,
        otp_fast2sms_api_key: null,
        otp_24x7sms_api_key: null,
        otp_24x7sms_sender_id: null,
        otp_24x7sms_sevicename: null,
        DLTTemplateID: null,
        template_message: null,
        status: null,
    });

    const [formDataError, setFormDataError] = useState({});
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false);
    const [loading, setLoading] = useState(true)
    const [defaultOption, setDefaultOption] = useState("");

    const formValidation = () => {
        let formIsValid = true;

        if (!formData?.otp_vai) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                otp_vai: "OTP cannot be empty.",
            }));
            combinedRef.current['otp_vai'].focus()
            formIsValid = false;
        }
        if (formData?.otp_vai == "fast2sms") {
            if (!formData?.otp_fast2sms_api_key) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    otp_fast2sms_api_key: "otp_fast2sms_api_key cannot be empty.",
                }));
                combinedRef.current['otp_fast2sms_api_key'].focus()
                formIsValid = false;
            }
        }
        if (formData?.otp_vai == "24x7sms") {
            if (!formData?.template_message) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    template_message: "template_message cannot be empty.",
                }));
                combinedRef.current['template_message'].focus()
                formIsValid = false;
            }
            if (!formData?.DLTTemplateID) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    DLTTemplateID: "DLTTemplateID cannot be empty.",
                }));
                combinedRef.current['DLTTemplateID'].focus()
                formIsValid = false;
            }
            if (!formData?.otp_24x7sms_sevicename) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    otp_24x7sms_sevicename: "otp_24x7sms_sevicename cannot be empty.",
                }));
                combinedRef.current['otp_24x7sms_sevicename'].focus()
                formIsValid = false;
            }
            if (!formData?.otp_24x7sms_sender_id) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    otp_24x7sms_sender_id: "otp_24x7sms_sender_id cannot be empty.",
                }));
                combinedRef.current['otp_24x7sms_sender_id'].focus()
                formIsValid = false;
            }
            if (!formData?.otp_24x7sms_api_key) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    otp_24x7sms_api_key: "otp_24x7sms_api_key cannot be empty.",
                }));
                combinedRef.current['otp_24x7sms_api_key'].focus()
                formIsValid = false;
            }


            const trimmedTemplateMessage = !formData?.template_message?.trim();
            if (trimmedTemplateMessage) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    template_message: "template_message cannot be empty.",
                }));
                combinedRef.current['template_message'].focus()
                formIsValid = false;
            }
        }

        return formIsValid;
    }


    const handleStore = async () => {
        if (formValidation()) {
            await handleAdd();
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (['otp_vai', 'otp_fast2sms_api_key', 'otp_24x7sms_api_key', 'otp_24x7sms_sender_id', 'otp_24x7sms_sevicename', 'DLTTemplateID', 'template_message', 'status'].includes(key)) {
                    formDataAdd[key] = formData[key];
                }
            }
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/OTP-Credentials-update`, formDataAdd, { headers: headers });
            const result = response?.data;

            if (result?.status) {
                setWithOutRefresh(!withOutRefresh)
                setShowOverlay(false);
                toast.success(result?.message)
            } else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        } catch (err) {

            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const EditData = async () => {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/OTP-Credentials-index`, { headers: headers });
        const result = response?.data;
        const editResult = result?.AdminOTPCredentials;
        const option = result?.otp_vai_data;
        if (response?.data?.status) {
            setFormData(editResult)
            setDefaultOption(option);
            setLoading(false);
        } else {
            console.error(result?.message)
            setLoading(false);
        }
    }

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: checked ? 1 : 0,
            })
            )
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                [name]: "",
            }));

        }

    }

    useEffect(() => {
        EditData()
    }, [withOutRefresh]);
    return (
        <div>
            {showOverlay && (<Response_Processing />)}
            <AdminSaveHeader heading={"OTP Credentials Setting"} saveText={"Save"} saveMethod={handleStore} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={"OTP Credentials Setting"} />
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <MessageLabel text="Enable OTP (signup & Login)" noMargin />
                            <AdminSwitch name={"status"} checked={formData?.status == 1} onChange={handleInput} />
                        </div>
                    </Wrapper>
                </LeftWrapper>

                <RightWrapper>
                    <Wrapper>
                        <MessageLabel text="Choose OTP Service" className="mandatorySimple" />
                        <AdminCustomSelect
                            name="otp_vai"
                            value={formData?.otp_vai || ""}
                            onChange={handleInput}
                            ref={(el) => (combinedRef.current.otp_vai = el)}
                            options={defaultOption?.length ? defaultOption.map(item => ({
                                name: item?.name,
                                value: item?.value
                            })) : []}
                            error={formDataError?.otp_vai}
                            defaultOptionName={"Select an option"}
                        />
                    </Wrapper>
                </RightWrapper>

                {/* Fast2SMS Fields */}
                <LeftWrapper>

                </LeftWrapper>

                {formData?.otp_vai === "fast2sms" && (
                    <RightWrapper>
                        <Wrapper>
                            <MessageLabel text="Fast2SMS API Key" className="mandatorySimple" />
                            <AdminCustomInput
                                type="text"
                                name="otp_fast2sms_api_key"
                                value={formData?.otp_fast2sms_api_key || ""}
                                onChange={handleInput}
                                placeHolder={"Fast2SMS API Key"}
                                ref={(el) => (combinedRef.current.otp_fast2sms_api_key = el)}
                                error={formDataError?.otp_fast2sms_api_key}

                            />
                        </Wrapper>
                    </RightWrapper>
                )}

                {/* 24x7sms Fields */}
                {formData?.otp_vai === "24x7sms" && (
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="card p-4 mb-4 h-100">
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <MessageLabel text="API KEY - 24x7sms" className="mandatorySimple" />
                                        <AdminCustomInput
                                            type="text"
                                            name="otp_24x7sms_api_key"
                                            value={formData?.otp_24x7sms_api_key || ""}
                                            onChange={handleInput}
                                            placeHolder="API KEY - 24x7sms"
                                            ref={(el) => (combinedRef.current.otp_24x7sms_api_key = el)}
                                            error={formDataError?.otp_24x7sms_api_key}
                                        />
                                    </div>

                                    <div className="col-12 mb-3">
                                        <MessageLabel text="Sender ID - 24x7 Sms" className="mandatorySimple" />
                                        <AdminCustomInput
                                            type="text"
                                            name="otp_24x7sms_sender_id"
                                            value={formData?.otp_24x7sms_sender_id || ""}
                                            onChange={handleInput}
                                            placeHolder="Sender ID - 24x7 Sms"
                                            ref={(el) => (combinedRef.current.otp_24x7sms_sender_id = el)}
                                            error={formDataError?.otp_24x7sms_sender_id}
                                        />
                                    </div>

                                    <div className="col-12 mb-3">
                                        <MessageLabel text="Service Name - 24x7 Sms" className="mandatorySimple" />
                                        <AdminCustomInput
                                            type="text"
                                            name="otp_24x7sms_sevicename"
                                            value={formData?.otp_24x7sms_sevicename || ""}
                                            onChange={handleInput}
                                            placeHolder="Service Name - 24x7 Sms"
                                            ref={(el) => (combinedRef.current.otp_24x7sms_sevicename = el)}
                                            error={formDataError?.otp_24x7sms_sevicename}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-md-6">
                            <div className="card p-4 mb-4 h-100">
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <MessageLabel text="DLT Template ID - 24x7 Sms" className="mandatorySimple" />
                                        <AdminCustomInput
                                            type="text"
                                            name="DLTTemplateID"
                                            value={formData?.DLTTemplateID || ""}
                                            onChange={handleInput}
                                            placeHolder="DLT Template ID - 24x7 Sms"
                                            ref={(el) => (combinedRef.current.DLTTemplateID = el)}
                                            error={formDataError?.DLTTemplateID}
                                        />
                                    </div>

                                    <div className="col-12 mb-3">
                                        <MessageLabel text="Template Message - 24x7 Sms" className="mandatorySimple" />
                                        <AdminCustomArea
                                            name="template_message"
                                            value={formData?.template_message || ""}
                                            onChange={handleInput}
                                            ref={(el) => (combinedRef.current.template_message = el)}
                                            placeHolder="Template Message - 24x7 Sms"
                                            rows={5}
                                            error={formDataError?.template_message}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </FormContainer>
        </div>
    )
}

export default OTPCredentialsSettings
